module.exports = {
    'url':'app'
}